"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMenuDisplayFormatter = exports.ActiveClass = exports.HighlightClass = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Colors_1 = require("../../styles/Colors");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var DomWidgets_1 = require("../DomWidgets");
var ListStyles_1 = require("../List/ListStyles");
var GroupLabelClass = 'grouplabel';
var HasDetailClass = 'hasdetail';
exports.HighlightClass = 'highlight';
exports.ActiveClass = 'active';
var StyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({ borderRadius: 2, boxSizing: 'border-box', height: ListStyles_1.ListAndMenuItemHeight, lineHeight: ListStyles_1.ListAndMenuItemHeight + "px", whiteSpace: 'nowrap' }, PreventUserSelect_1.PreventUserSelect), { $nest: (_a = {
            // item container
            '[role^="menuitem"] > &, [role="option"] > &': {
                paddingLeft: ListStyles_1.ListAndMenuPadding,
                paddingRight: ListStyles_1.ListAndMenuPadding,
            }
        },
        _a["&." + GroupLabelClass] = { fontWeight: 'bold' },
        _a["&." + HasDetailClass] = {
            fontWeight: 'bold',
            height: 'auto',
            minHeight: ListStyles_1.ListAndMenuItemHeight * 2,
            lineHeight: ListStyles_1.ListAndMenuItemHeight - 4 + "px",
            paddingBottom: 4,
            paddingTop: 4,
            whiteSpace: 'normal',
        },
        // interactive states
        _a["&." + exports.HighlightClass + ", &." + exports.ActiveClass] = {
            outline: "1px solid " + Colors_1.ListAndMenuColors.ActiveBorder,
            outlineOffset: -1,
        },
        _a["&." + exports.HighlightClass] = {
            backgroundColor: Colors_1.ListAndMenuColors.Hover,
        },
        _a["&." + exports.ActiveClass] = {
            backgroundColor: Colors_1.ListAndMenuColors.Active,
        },
        _a['[role^="menuitem"] > &:active, [role="option"] > &:active'] = {
            backgroundColor: Colors_1.ListAndMenuColors.Press,
        },
        _a['[aria-disabled="true"] > &'] = {
            backgroundColor: 'transparent !important',
            color: Colors_1.ListAndMenuColors.DisabledText + " !important",
        },
        _a) }));
// item icon, text, and annotation
var GutterStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    flexShrink: 0,
    flexGrow: 0,
    marginLeft: -ListStyles_1.ListAndMenuPadding + 1,
    justifyContent: 'center',
    width: 22, // 10px icon + 2 * ListAndMenuPadding, or 14px icon + 2 * 4px spacing, same same!
});
var TextStyleName = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, TextEllipsis_1.TextEllipsis), { flexGrow: 1 }));
var AnnotationStyleName = TypeStyle.style({
    alignItems: 'center',
    color: Colors_1.TextColors.Neutral,
    display: 'inline-flex',
    flexShrink: 0,
    marginLeft: 8,
});
var DetailStyleName = TypeStyle.style({ fontWeight: 'normal' });
function isUrl(s) {
    try {
        new URL(s);
    }
    catch (_a) {
        return false;
    }
    return true;
}
function renderIcon(Icon) {
    if (isUrl(Icon)) {
        return React.createElement(DomWidgets_1.Img, { src: Icon, "aria-hidden": true });
    }
    else if (typeof Icon === 'string') {
        return Icon;
    }
    else if (Icon) {
        var iconAriaPropsForTesting = { role: 'img' }; // tsc complains if this is assigned inline and we don't want to augment the external typedef
        return React.createElement(Icon, tslib_1.__assign({ size: 14, "aria-hidden": true }, iconAriaPropsForTesting));
    }
    else {
        return null;
    }
}
/**
 * @param displayValue text value to display
 * @param tooltipOverride tooltip to display (overrides default overflow-tooltip behavior)
 */
var TextMenuDisplayFormatter = function (displayValue, tooltipOverride) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(TextFormatterWidget, _super);
        function TextFormatterWidget() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = { title: tooltipOverride };
            _this.handleMouseOver = function (e) {
                if (tooltipOverride) {
                    // NOTE: The custom title will override the default title when the displayed value within the menu item is truncated.
                    return;
                }
                var textNodes = Array.from(e.currentTarget.querySelectorAll("." + TextStyleName + ", ." + DetailStyleName));
                _this.setState({ title: textNodes.some(DomUtil_1.isElementOverflownX) ? textNodes.map(function (n) { return n.textContent; }).join(Localize_1.Messages.colonSeparator()) : undefined });
            };
            return _this;
        }
        TextFormatterWidget.prototype.render = function () {
            var _a;
            var showGutter = this.props.showIconGutter && !this.props.isGroupLabel;
            return (
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            React.createElement("div", { className: TypeStyle.classes(StyleName, this.props.isGroupLabel ? GroupLabelClass : (_a = {},
                    _a[exports.ActiveClass] = this.props.active,
                    _a[HasDetailClass] = !!this.props.detail,
                    _a[exports.HighlightClass] = this.props.isHighlighted,
                    _a)), "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'TextMenuItem'), onMouseOver: this.handleMouseOver, title: this.state.title },
                React.createElement("div", { style: { display: 'flex' } },
                    showGutter && React.createElement("span", { key: 'gutter', className: GutterStyleName }, renderIcon(this.props.icon)),
                    React.createElement("span", { key: 'text', className: TextStyleName }, displayValue /* this has to be in a span for text eliding to work in a flexbox */),
                    this.props.annotation && React.createElement("span", { key: 'annotation', className: AnnotationStyleName }, renderIcon(this.props.annotation))),
                this.props.detail && React.createElement("div", { key: 'detail', className: DetailStyleName }, this.props.detail)));
        };
        return TextFormatterWidget;
    }(React.PureComponent));
};
exports.TextMenuDisplayFormatter = TextMenuDisplayFormatter;
//# sourceMappingURL=TextMenuDisplayFormatter.js.map